class ScrollSpy {
  constructor(container, onScroll){
    this.container = container;
    this.anchors = null;
    this.scrollables = [];
    this.paddingLeft = 0;

    this.init();
  }

  init() {
    this.anchors = Array.from(this.container.querySelectorAll('[href^="#"'));
    this.bindHandlers();
  }

  bindHandlers() {
    this.anchors.forEach(anchor => {
      const target = document.querySelector(anchor.getAttribute("href"));

      if( target ) {
        this.scrollables.push(target);
      }

      anchor.addEventListener('click', e => {
        e.preventDefault();
        const { top } = target.getBoundingClientRect();

        window.scroll({
          top: top + window.scrollY - this.getPageScrollOffset(),
          behavior: 'smooth'
        });
      })
    });

    for (let scrollable of this.scrollables) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => this.handleScroll(entry));
        },
        {
          root: null,
          rootMargin: '-50% 0px',
          threshold: 0
        }
      );
      observer.observe(scrollable);
    }
  }

  handleScroll(entry) {
    const { target, isIntersecting } = entry;
    const anchor = this.anchors.find(anchor => {
      return anchor.getAttribute("href") === `#${target.id}`
    });

    if( isIntersecting ) {
      anchor.classList.add('is-active');

      const { left } = anchor.getBoundingClientRect();
      const scrollParent = this.getScrollParent(this.container);

      if( scrollParent !== document.documentElement ) {
        scrollParent.scroll({ 
          left: left + scrollParent.scrollLeft - this.getScrollParentOffset(),
          behavior: 'smooth'
        });
      }     
    } else {
      anchor.classList.remove('is-active');
    }
  }

  getScrollParent(node) {
    if (node == null) {
      return null;
    }
  
    if (node.scrollHeight > node.clientHeight || node.scrollWidth > node.clientWidth) {
      return node;
    } else {
      return this.getScrollParent(node.parentNode);
    }
  }

  getScrollParentOffset() {
    const scrollParent = this.getScrollParent(this.container);
    const styles = getComputedStyle(scrollParent);
    const paddingLeft = styles.getPropertyValue('padding-left');
    return scrollParent !== document.documentElement ? parseInt(paddingLeft, 10) : 0;
  }

  getPageScrollOffset(){
    const styles = getComputedStyle(document.documentElement);
    const scrollPaddingTop = styles.getPropertyValue('scroll-padding-top');
    return scrollPaddingTop ? parseInt(scrollPaddingTop, 10) : 0;
  }
}

document.querySelectorAll('.js-ScrollSpy').forEach( 
  element => new ScrollSpy(element)
);